import { Navigate } from 'react-router-dom';

// 파일명과 구현 의도 불일치 정리:
// - 기존 파일은 "회원 탈퇴 사유 수집 UI" 였으나 라우트 의도는 "출금 계좌 관리".
// - 실제 탈퇴 기능은 본페이지(/partner/mypage)의 handleWithdraw 에서 제공.
// - 제휴업체 출금 계좌 관리 UI 는 별도 구현 예정.
const WithdrawAccount = () => <Navigate to="/partner/mypage" replace />;

export default WithdrawAccount;
